import { Pipe, PipeTransform } from '@angular/core';
import { companyDisplayName } from '../utils/company-display-name';

@Pipe({ name: 'companyName' })
export class CompanyNamePipe implements PipeTransform {
  transform(company: any, lang?: string | null, extra?: string | null): string {
    return companyDisplayName(company, lang, extra);
  }
}
